import { Schema } from 'rsuite'

const { StringType, ArrayType, NumberType } = Schema.Types

export const DeliveryZoneFormValidationModel = Schema.Model({
  name: StringType().isRequired('Заполните название'),
  status: NumberType()
    .min(0, 'Вес не может быть отрицательным')
    .isRequired('Заполните вес'),
  zoneGeoDeliveryZone: ArrayType()
    .isRequired('Нарисуйте зону'),
  // price checks
  // singlePrice: NumberType().addRule((value, otherFields) => {
  //   return otherFields.useSinglePrice ? value >= 0 : true
  // }, 'Установите цену больше 0')
})
